<template>

  <div :class="['axiome-logique-container', 'axiome-logique-intersection-of']">
    <span class="brace-container-left" />

    <div :class="['display-flew-column', { 'display-flew-column-level0': level0 }]">
      <PropertyValue :values="otherIntersectionOfLiterals" :leftMargin="false" :showLanguageBadge="showLanguageBadge"
        axiomLogicOperand="and" />

      <AttributeBlankNode :blankNodes="blankNodes" :leftMargin="false" :braceDisplay="true"
        :showLanguageBadge="showLanguageBadge" axiomLogicOperand="and"
        :showFirstOperand="otherIntersectionOfLiterals !== undefined && otherIntersectionOfLiterals.length > 0" />
    </div>
  </div>

</template>

<script>

export default {
  name: "LogicalAxiomeIntersectionOf",
  computed: {

    otherIntersectionOfLiterals() {
      let literals = [];
      this.otherIntersectionOf.forEach(element => {
        literals.push(...element.literals);
      });
      return literals;
    },
    blankNodes() {
      let blankNodes = [];
      this.otherIntersectionOf.forEach(element => {
        blankNodes.push(...element.blankNodes);
      });
      return blankNodes;
    }
  },
  props: {
    level0: {
      type: Boolean,
      default: false
    },
    otherIntersectionOf: {
      type: Array,
      default: () => []
    },
    showLanguageBadge: {
      type: Boolean,
      default: false
    }
  }
}
</script>
